import { render } from "./InitiativesPanel.vue?vue&type=template&id=036b7a1d&scoped=true"
import script from "./InitiativesPanel.vue?vue&type=script&lang=js"
export * from "./InitiativesPanel.vue?vue&type=script&lang=js"

import "./InitiativesPanel.vue?vue&type=style&index=0&id=036b7a1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b7a1d"]])

export default __exports__